import { Menubar } from './scripts/a11y-navigation/Menubar';
import throttle from 'lodash.throttle';
import { TrialForm } from '../../molecules/trial-form/trial-form';

class Header {
    constructor() {
        this.nodes = {
            navMenuTrigger: document.querySelectorAll('.js-nav-menu-trigger'),
            header: document.querySelector('.header'),
            headerShadow: document.querySelector('.header__shadow'),
            widgetIntro: document.querySelector('.widget-intro'),
            body: document.body,
            subMenuTriggerMobile: document.querySelectorAll('.js-sub-menu-trigger-mobile'),
            formGroup: document.querySelector('.header-form-group'),
            formTrigger: document.querySelector('.header-trial-form-trigger'),
            contactSales: document.querySelector('.header__nav-group-item--contact-sales'),
        };

        this.headerHeight = this.nodes.header.clientHeight;
        this.opacityScrollRate = 500;
        this.stickPoint = 0;
        this.activeMenuItem = null;
        this.activeSubMenu = null;
        this.isWithTheme = true;
        this.isNavOpen = false;
        this.isTrialOpen = false;
        this.theme = this.nodes.widgetIntro ? this.nodes.widgetIntro.getAttribute('data-theme') : 'default';
        this.nodes.header.classList.add('header--theme-' + this.theme);
        this.headerStickyTheme = this.nodes.header.getAttribute('data-sticky-theme')
            ? this.nodes.header.getAttribute('data-sticky-theme')
            : 'default';

        this.initNavMenu();
        this.initTrialForm();

        window.addEventListener(
            'scroll',
            throttle(() => {
                this.onScroll();
            }, 50)
        );
    }

    initTrialForm() {
        const formsCollection = this.nodes.header.querySelectorAll('.trial-form');

        [].forEach.call(formsCollection, (formNode) => {
            const trialForm = new TrialForm(formNode);

            trialForm.init();

            if (!formNode.classList.contains('header-trial-form-mobile')) {
                document.addEventListener('click', (event) => {
                    const isFormTriggerEnable =
                        event.target === this.nodes.formTrigger || event.target.parentNode === this.nodes.formTrigger;

                    const isFormTriggerDisable =
                        event.target !== trialForm.fields.email.control &&
                        trialForm.fields.button.node !== event.target.parentNode &&
                        !trialForm.fields.email.dirty &&
                        this.isTrialOpen;

                    if (isFormTriggerEnable) {
                        this.nodes.formGroup.classList.add('header-form-group--opened');
                        trialForm.fields.email.control.focus();
                        this.isTrialOpen = true;
                        this.nodes.contactSales.hidden = true;
                    }

                    if (isFormTriggerDisable) {
                        this.nodes.formGroup.classList.remove('header-form-group--opened');
                        trialForm.resetFormStatuses();
                        this.isTrialOpen = false;
                        this.nodes.contactSales.hidden = false;
                    }
                });
            }
        });
    }

    initNavMenu() {
        const navMenuTrigger = [].slice.call(this.nodes.navMenuTrigger);
        const subMenuTriggerMobile = [].slice.call(this.nodes.subMenuTriggerMobile);

        navMenuTrigger.forEach((item) => {
            item.addEventListener('click', () => {
                this.nodes.body.classList.toggle('page--nav-opened');
                this.isNavOpen = !this.isNavOpen;
            });
        });

        subMenuTriggerMobile.forEach((item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                const targetElement = event.target;
                const subMenu = targetElement.nextElementSibling;

                if (subMenu.style.maxHeight) {
                    targetElement.classList.remove('header-menu-mobile__link--opened');
                    subMenu.style.maxHeight = null;
                    this.activeMenuItem = null;
                    this.activeSubMenu = null;
                } else {
                    subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
                    targetElement.classList.add('header-menu-mobile__link--opened');

                    if (this.activeSubMenu && this.activeMenuItem) {
                        this.activeSubMenu.style.maxHeight = null;
                        this.activeMenuItem.classList.remove('header-menu-mobile__link--opened');
                    }

                    this.activeMenuItem = targetElement;
                    this.activeSubMenu = subMenu;
                }
            });
        });
    }

    onScroll() {
        const clientScrollOffset = window.pageYOffset;
        const isReadyToStuck = clientScrollOffset > this.stickPoint && !this.stuck;
        const isReadyToUnstuck = clientScrollOffset <= this.stickPoint && this.stuck;

        this.initShadow(clientScrollOffset);

        if (this.nodes.widgetIntro && this.theme !== this.headerStickyTheme) {
            this.changeStickyTheme();
        }

        if (isReadyToStuck) {
            this.stuck = true;
            this.nodes.header.classList.add('header--sticky');
            if (this.nodes.contactSales) {
                this.nodes.contactSales.hidden = true;
            }
        }
        if (isReadyToUnstuck) {
            this.stuck = false;
            this.nodes.header.classList.remove('header--sticky');
            if (this.nodes.contactSales) {
                this.nodes.contactSales.hidden = false;
            }
        }
    }

    initShadow(pageScrollOffset) {
        let opacityValue = '1';

        if (pageScrollOffset < this.opacityScrollRate) {
            opacityValue = pageScrollOffset / this.opacityScrollRate;
        }

        this.nodes.headerShadow.style.opacity = opacityValue;
    }

    changeStickyTheme() {
        const introScrollOffset = this.nodes.widgetIntro.getBoundingClientRect();
        const isHeaderOverIntro =
            introScrollOffset.top <= this.headerHeight && introScrollOffset.bottom > this.headerHeight;
        const isHeaderUnderIntro = introScrollOffset.bottom <= this.headerHeight;

        if (isHeaderOverIntro && !this.isWithTheme) {
            this.isWithTheme = true;
            this.nodes.header.classList.add('header--theme-' + this.theme);
            this.nodes.header.classList.remove('header--theme-' + this.headerStickyTheme);
        }

        if (isHeaderUnderIntro && this.isWithTheme) {
            this.isWithTheme = false;
            this.nodes.header.classList.remove('header--theme-' + this.theme);
            this.nodes.header.classList.add('header--theme-' + this.headerStickyTheme);
        }
    }
}

const isLightHeader = document.querySelector('.header--light');

if (!isLightHeader) {
    const menubar = new Menubar(document.querySelector('.header-menu__list'));

    menubar.init();

    const languageSelector = new Menubar(document.querySelector('.header-language-selector'));

    languageSelector.init();
}

const header = new Header();



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/organisms/header/header.js